"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const FormControlLabel_1 = __importDefault(require("@mui/material/FormControlLabel"));
const Paper_1 = __importDefault(require("@mui/material/Paper"));
const TextField_1 = __importDefault(require("@mui/material/TextField"));
const styles_1 = require("@mui/material/styles");
const mui_1 = require("tss-react/mui");
const SelectField_1 = __importDefault(require("components/SelectField"));
const styles = (theme) => ({
    root: {
        paddingRight: theme.spacing(1),
        minHeight: 30,
    },
    highlight: theme.palette.mode === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: (0, styles_1.lighten)(theme.palette.secondary.light, 0.85),
        }
        : {
            color: theme.palette.text.secondary,
            backgroundColor: theme.palette.secondary.dark,
        },
    spacer: {
        flex: '1 1 100%',
    },
    actions: {
        color: theme.palette.text.primary,
    },
    title: {
        flex: '0 0 auto',
    },
    formContainer: {
        display: 'flex',
        padding: '10px 24px 10px 24px',
        background: theme.palette.offWhite,
        flexDirection: 'row',
        flexFlow: 'wrap',
    },
    formLabel: {
        alignItems: 'flex-start',
    },
    textField: {
        marginRight: 15,
        marginBottom: 15,
        display: 'inline-block',
        flexDirection: 'column',
        color: theme.palette.graniteGrey,
        minWidth: 120,
        '& input': {
            fontSize: theme.components.register.fontSize.default,
            lineHeight: theme.components.register.fontSize.default,
        },
    },
    button: {
        verticalAlign: 'bottom',
    },
});
const useStyles = (0, mui_1.makeStyles)()(styles);
const QListDetails = (props) => {
    const { classes } = useStyles();
    const [stateData, setStateData] = (0, react_1.useState)(props.data);
    const focusField = (0, react_1.useRef)(null);
    let takeFocus = true;
    const focusRef = (x) => {
        focusField.current = x;
    };
    const isNumber = (type) => (type === 'number');
    const saveData = () => {
        if (props.onSave) {
            // convert numeric fields to numbers as requested
            props.dataDictionary.forEach((col) => {
                if (isNumber(col.type)) {
                    stateData[col.id] = Number(stateData[col.id]);
                }
            });
            props.onSave(stateData);
        }
    };
    const onKeyDown = (e, checkIsNumber, filter = []) => {
        switch (e.key) {
            case 'Tab':
            case 'ArrowUp':
            case 'ArrowDown':
            case 'ArrowRight':
            case 'ArrowLeft':
            case 'Backspace':
            case 'Delete':
                break;
            case 'Enter':
                saveData();
                if (props.onEscape) {
                    props.onEscape();
                }
                break;
            case 'Escape':
                if (props.onEscape) {
                    props.onEscape();
                }
                break;
            default:
                // @ts-expect-error TS(2345) - FIXME: Argument of type 'any' is not assignable to parameter of type 'never'.
                if (filter && filter.indexOf(e.key) >= 0) {
                    e.stopPropagation();
                    e.preventDefault();
                }
                if (checkIsNumber) {
                    if ('012345678990+-.'.indexOf(e.key) === -1) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }
                break;
        }
    };
    const handleChange = (val, id) => {
        const newData = Object.assign({}, stateData);
        newData[id] = val;
        // setStateData({ data: newData });
        setStateData(newData);
    };
    const handleCustomChange = (val, id) => {
        const newData = Object.assign({}, stateData);
        newData.values[id] = val;
        // setStateData({ data: newData });
        setStateData(newData);
    };
    (0, react_1.useEffect)(() => {
        setTimeout(() => {
            // if (focusRef && focusField?.current) {
            if (focusField.current) {
                focusField.current.focus();
                focusField.current.select();
            }
        }, 50);
    }, []);
    return (<Paper_1.default>
      <form className={(0, classnames_1.default)(props.className, classes.formContainer)} noValidate autoComplete="off">
        {props.dataDictionary.map((col) => {
            var _a, _b, _c;
            const EditComponent = col.component || TextField_1.default;
            const customProps = col.inputProps || {};
            let ret;
            /* eslint-disable jsx-a11y/no-static-element-interactions */
            if (col.choices && col.editable) {
                const children = col.choices.map((x) => {
                    const obj = { name: col.type === 'icon' ? col.stringToIcon(x, true) : x, value: x };
                    return obj;
                });
                ret = (<div onKeyDown={(e) => onKeyDown(e, isNumber(col.type))} key={`qlist_details_edit:${col.id}`} className={classes.textField}>
                <FormControlLabel_1.default classes={{ labelPlacementTop: classes.formLabel }} control={<SelectField_1.default value={stateData[col.id]} name={col.type === 'icon' ? col.stringToIcon(stateData[col.id]) : ''} onKeyDown={(e) => onKeyDown(e, isNumber(col.type))} onChange={(e) => handleChange(e, col.id)} idPrefix={`create-new-${(_a = col.label) === null || _a === void 0 ? void 0 : _a.toLowerCase()}`}>
                      {children}
                    </SelectField_1.default>} label={col.label} labelPlacement="top"/>
              </div>);
            }
            else {
                const useCustomValue = (stateData.values && stateData.values[col.id]);
                /* eslint-disable react/jsx-no-duplicate-props */
                ret = (<div onKeyDown={(e) => onKeyDown(e, isNumber(col.type), col.filter)} key={`qlist_details_edit:${col.id}`} className={classes.textField} id={`qlist-details-edit-${col.id}`}>
                <FormControlLabel_1.default classes={{ labelPlacementTop: classes.formLabel }} control={<EditComponent disabled={!col.editable} value={useCustomValue ? ' ' : stateData[col.id] || ''} onChange={!useCustomValue ?
                            (e) => handleChange(e.target.value, col.id) :
                            (e) => handleCustomChange(e, col.id)} InputProps={{
                            'aria-label': col.label,
                            inputComponent: col.inputComponent,
                        }} inputProps={useCustomValue ? Object.assign(Object.assign({}, customProps), { 'aria-label': col.id, value: stateData.values[col.id] || '', id: `create-new-${(_b = col.id) === null || _b === void 0 ? void 0 : _b.toLowerCase()}`, maxLength: col.maxLength }) : Object.assign(Object.assign({}, customProps), { 'aria-label': col.id, ref: takeFocus ? focusRef : null, id: `create-new-${(_c = col.id) === null || _c === void 0 ? void 0 : _c.toLowerCase()}`, maxLength: col.maxLength })}/>} label={col.label} labelPlacement="top"/>
              </div>);
            }
            takeFocus = false;
            return ret;
        })}

        <Button_1.default color="primary" className={classes.button} onClick={props.onEscape} id="create-new-cancel-button">
          Cancel
        </Button_1.default>
        <Button_1.default color="primary" className={classes.button} onClick={saveData} id="create-new-save-button">
          Save
        </Button_1.default>
      </form>
    </Paper_1.default>);
};
exports.default = (0, react_1.memo)(QListDetails);
